import MobileSubmitView from "../Components/MobileSubmitView";
import { MobileSubmitViewPropsType } from "../MobileSubmitViewPropsType";

export default function MobileSubmitViewContainer({
  reducerState,
  questionObjVariable,
  surveyAnswers,
  setSurveyAnswers,
  mainRefObject,
  checkNestedDependency,
  isPreview,
  dependencyAnsHash,
  setDependencyAnsHash,
  clearValuesFromSurveyAnswers,
  dispatch,
  surveyAnswersInfo,
  oldOption,
  handleNextPage,
  monthsHash,
  params,
}: MobileSubmitViewPropsType) {
  return (
    <MobileSubmitView
      reducerState={reducerState}
      questionObjVariable={questionObjVariable}
      surveyAnswers={surveyAnswers}
      setSurveyAnswers={setSurveyAnswers}
      mainRefObject={mainRefObject}
      checkNestedDependency={checkNestedDependency}
      isPreview={isPreview}
      dependencyAnsHash={dependencyAnsHash}
      setDependencyAnsHash={setDependencyAnsHash}
      clearValuesFromSurveyAnswers={clearValuesFromSurveyAnswers}
      dispatch={dispatch}
      surveyAnswersInfo={surveyAnswersInfo}
      oldOption={oldOption}
      handleNextPage={handleNextPage}
      monthsHash={monthsHash}
      params={params}
    />
  );
}
